import { render } from "./Page.vue?vue&type=template&id=563ae6ee&scoped=true"
const script = {}

import "./Page.vue?vue&type=style&index=0&id=563ae6ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563ae6ee"]])

export default __exports__